{
  "fallback": {
    "message": "Sorry, deze pagina is tijdelijk onbeschikbaar. Onze ingenieurs zijn verwittigd en gaan er direct mee aan de slag.<br> Probeer het later opnieuw.",
    "linkMessage": "Terug naar de homepage"
  },
  "sites": [
    //  Template for an error message:
    //  If no site is selected, the standard message for Wieni will be displayed
    // {
    //   "name"           Required
    //   "match"          Required
    //   "color"          Required
    //   "link"           Required
    //   "textColor"      Optional  (default is white)
    //   "messageTitle"   Optional  (default is fallback)
    //   "message"        Optional  (default is fallback)
    //   "linkMessage"    Optional  (default is fallback)
    // },
    {
      "name": "www.goplay.be",
      "match": "goplay",
      "color": "#14191e",
      "link": "https://www.goplay.be",
      "message": "Deze pagina werd gesaboteerd door de mol. We doen ons best om deze snel terug te zetten.",
      "linkMessage": "Terug naar de homepage"
    },
    {
      "name": "www.bruzz.be",
      "match": "bruzz",
      "color": "#404040",
      "link": "https://www.bruzz.be"
    },
    {
      "name": "www.dagelijksekost.een.be",
      "match": "dagelijksekost",
      "color": "#1f2729",
      "link": "https://dagelijksekost.een.be"
    },
    {
      "name": "www.gondola.be",
      "match": "gondola",
      "color": "#fc0f3d",
      "link": "https://www.gondola.be"
    },
    {
      "name": "www.joker.be",
      "match": "joker",
      "color": "#316f3b",
      "link": "https://www.joker.be"
    },
    {
      "name": "www.klj.be",
      "match": "klj",
      "color": "#E5F7FA",
      "textColor": "#000000",
      "link": "https://www.klj.be"
    },
    {
      "name": "www.mediarte.be",
      "match": "mediarte",
      "color": "#af1280",
      "link": "https://www.mediarte.be"
    },
    {
      "name": "www.motoren-toerisme.be",
      "match": "motoren-toerisme",
      "color": "#000000",
      "link": "https://www.motoren-toerisme.be"
    },
    {
      "name": "www.sbsbelgium.be",
      "match": "sbsbelgium",
      "color": "#2f98ac",
      "link": "https://www.sbsbelgium.be"
    },
    {
      "name": "www.uzleuven.be",
      "match": "uzleuven",
      "color": "#1f2e55",
      "link": "https://www.uzleuven.be"
    },
    {
      "name": "www.vier.be",
      "match": "vier",
      "color": "#e91219",
      "link": "https://www.vier.be"
    },
    {
      "name": "www.vrtsales.be",
      "match": "vrtsales",
      "color": "#16274a",
      "link": "https://www.vrtsales.be"
    },
    {
      "name": "www.watwat.be",
      "match": "watwat",
      "color": "#e5eaef",
      "textColor": "#1774ef",
      "link": "https://www.watwat.be"
    },
    {
      "name": "www.wtfock.be",
      "match": "wtfock",
      "color": "#000000",
      "link": "https://www.wtfock.be"
    },
    {
      "name": "www.eoswetenschap.eu",
      "match": "eos",
      "color": "#ffffff",
      "textColor": "#000000",
      "link": "https://www.eoswetenschap.eu"
    },
    {
      "name": "www.wieni.be",
      "match": "wieni",
      "color": "#33105e",
      "link": "https://www.wieni.be"
    },
    {
      "name": "www.nuvoormorgen.be",
      "match": "nuvoormorgen",
      "color": "#cbdff3",
      "textColor": "#000000",
      "link": "https://www.nuvoormorgen.be"
    },
    {
      "name": "www.pvda.be",
      "match": "pvda",
      "color": "#D8002F",
      "textColor": "#FFFFFF",
      "link": "https://www.pvda.be"
    },
    {
      "name": "www.ptb.be",
      "match": "ptb",
      "color": "#D8002F",
      "textColor": "#FFFFFF",
      "link": "https://www.ptb.be",
      "message": "Désolé, cette page est temporairement indisponible. Nos ingénieurs ont été prévenus et se mettront immédiatement au travail. Réessayez plus tard.",
      "linkMessage": "Retour à la page d'accueil"
    },
    {
      "name": "www.mediawijs.be",
      "match": "mediawijs",
      "color": "#33105e",
      "link": "https://www.mediawijs.be"
    }
  ]
}
